import styled from '@mui/material/styles/styled'
import { ReactNode } from 'react'

interface ItemContainerProps {
  small?: boolean
}

const ItemContainer = styled('div')(({ theme }) => ({
  margin: 0,
  marginBottom: '2rem',
  display: 'inline-block',
  verticalAlign: 'top',
  width: '100%',
  '&.small': {
    width: 'calc(50% - 1rem)',
    marginRight: '1rem',
    '~ .small': {
      width: '50%',
      marginRight: 0,
    },
  },

  [theme.breakpoints.up('sm')]: {
    width: 'calc(50% - 1rem)',
    marginRight: '1rem',
    '&.small': {
      width: 'calc(25% - 1rem)',
      '~ .small': {
        width: '25%',
        marginRight: 0,
      },
    },
    '&.regular:nth-of-type(2n + 3)': {
      // skip the first, fixed row of 3 (1 regular 2 small)
      width: '50%',
      marginRight: 0,
    },
  },
}))

const ListItemTitle = styled('dt')({
  margin: 0,
  marginBlock: 0,
  marginInline: 0,
  padding: 0,
  marginBottom: '0.25rem',
  fontSize: '0.875rem',
  lineHeight: '22 / 14',
  fontWeight: 500,
  color: '#595959',
})

const ListItemValue = styled('dd')({
  margin: 0,
  marginBlock: 0,
  marginInline: 0,
  padding: 0,
  fontSize: '1rem',
  lineHeight: '24 / 16',
  fontWeight: 400,
  color: '#262626',
})

interface DetailItemProps extends ItemContainerProps {
  heading: string
  children: ReactNode
}

const DetailItem = ({
  heading,
  children,
  small = false,
}: DetailItemProps): JSX.Element | null => {
  if (Array.isArray(children) && children.length === 0) return null

  if (!children) return null

  return (
    <ItemContainer className={`item-container ${small ? 'small' : 'regular'}`}>
      <ListItemTitle>{heading}</ListItemTitle>
      <ListItemValue>{children}</ListItemValue>
    </ItemContainer>
  )
}

export default DetailItem
